import { addStyles } from 'ethcss'
import { colors, IStyles } from 'theme'

const styles: IStyles = {
    table: {
        width: '100%',
        border: `1px solid ${colors.greyLight}`,
        textAlign: 'center',
    },
    th: {
        padding: 10,
        height: 42,
        verticalAlign: 'middle',
        border: `1px solid ${colors.greyLight}`,
    },
    td: {
        padding: 10,
        border: `1px solid ${colors.greyLight}`,
        height: 40,
        verticalAlign: 'middle',
    },
    tdCheckbox: {
        padding: '10px 0 10px 10px',
        width: 40,
    },
    tdArrow: {
        width: 40,
    },
    tdStatus: {
        width: '15%',
    },
    tdProgress: {
        width: '10%',
    },
    tdName: {
        width: '20%',
    },
    tdUpdateType: {
        width: '20%',
    },
    tdDate: {
        width: '20%',
    },
    tdMessage: {
        width: '15%',
    },
    iconAndName: {
        display: 'flex',
        alignItems: 'center',
    },
    selected: {
        backgroundColor: colors.greyLight,
    },
}

addStyles(styles)
export default styles
